import { HttpInterceptorFn } from '@angular/common/http';
import { PLATFORM_ID, inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';

/**
 * environment.apiBaseUrl es una ruta relativa ("/api/v1") a propósito: en el
 * navegador funciona sola (mismo origen que nginx, tanto en test como en
 * prod, sin necesitar un build distinto por ambiente). Pero durante SSR no
 * hay navegador/Host que resuelva rutas relativas — fetch() en Node exige
 * una URL absoluta. Este interceptor solo actúa server-side, reescribiendo
 * el prefijo /api/v1 con la URL absoluta real del backend (API_BASE_URL,
 * ya configurada correctamente por ambiente en el proceso de PM2).
 */
export const ssrApiBaseInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformServer(platformId) || !req.url.startsWith('/api/v1')) {
    return next(req);
  }

  const apiBaseUrl = process.env['API_BASE_URL'] || 'http://localhost:8080/api/v1';
  const absoluteUrl = req.url.replace(/^\/api\/v1/, apiBaseUrl);
  return next(req.clone({ url: absoluteUrl }));
};
